export default __webpack_public_path__ + "static/service-c8cdd52d4eb7dc0d5658e753635090ee.jpg";